import Services from "./Services";
import TitleBarMin from "@/components/elements/TitleBar/TitleBarMin";

const ServicesPage = () => {
  return (
    <>

      {/* <TitleBarMin title="Services"></TitleBarMin> */}

      <div className='mb-4'>
        {/* For the gap below nav */}
        <p>For the gap below nav</p>
      </div>
      <Services />



    </>
  );
};

export default ServicesPage;
